import React from "react";
import Button from "../../components/button";

export default function ReportPieceSuccessPage() {
    return <div className="page report-page">
        <h1>Report Submitted</h1>
        <p>Thank you for submitting your report. We take all reports seriously and will review the piece in question as soon as possible. If we find that the piece violates our guidelines, we will take appropriate action.</p>
        <p>We appreciate your help in keeping our community safe and enjoyable for everyone.</p>
        <Button onClick={() => {
            window.location.href = "/pieces"
        }}>Back to Pieces</Button>
    </div>
}